export default "__VITE_ASSET__Cjl0zRI9__"